import type { SpotBookingBookingLike, SpotBookingModelObj } from './types';

export function getModelObj(details: SpotBookingBookingLike): SpotBookingModelObj | undefined {
  return details.modelObj ?? details.model_obj;
}
